import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { utils } from "@vilocnv/allsetra-core";
import { MileageCorrectionData } from "../types";

export const useMileageCorrection = (specificObject: any) => {
  const { i18n } = useTranslation();

  const mileageData = useMemo(() => {
    const correctionDate = specificObject?.correctionDate;
    const newMileage = specificObject?.mileageCorrection;
    const comment = specificObject?.comment;

    const currentMileageField = specificObject?.metadata?.find(
      (item: any) => item.field?.id === 10
    );
    const lastReportedMileage = currentMileageField?.value
      ? parseFloat(currentMileageField.value)
      : 0;

    return {
      correctionDate,
      newMileage,
      comment,
      lastReportedMileage,
      systemCalculatedMileage: lastReportedMileage
    };
  }, [specificObject]);

  const formatDate = (dateString?: string) => {
    if (!dateString) return "-";
    return utils.formatDate({
      date: dateString,
      dateFormat: "eee, MMM dd, yyyy",
      language: i18n.language
    });
  };

  const formatMileage = (mileage?: number) => {
    return mileage ? `${mileage.toLocaleString().replace(".", ",")} km` : "-";
  };

  const truncateText = (text?: string, maxLength: number = 50) => {
    if (!text) return "-";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  return {
    ...mileageData,
    formatDate,
    formatMileage,
    truncateText
  };
};
